export const FORM_ID = 'book-now-review-form';
export const FORM_ERROR = 'form-error';
// Form Fields
export const OCCASION = 'selectedOccasion';
export const DEPARTURE_TIME = 'departureTime';
export const DEPARTURE_TIME_ID = 'departureTimeId';
export const RETURN_TIME = 'returnTime';
export const MESSAGE = 'ownerMessage';
export const GUESTS = 'guests';
export const ADULTS = 'adults';
export const CAPTAINED = 'captained';

export const PARAM_KEYS = {
  /** optional */
  SESSION_KEY: 'sessionKey',
  DATE: 'date',
  DURATION: 'duration',
  CAPACITY: 'capacity',
  CAPTAIN_OPTION: 'captain_option',
};
